import React from 'react';

export const ExternalError = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--external-error';
  color = color || '#0076CC';

  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M11.7084 3.55567L11.2124 3.06067C10.8374 2.68573 10.3287 2.4751 9.79842 2.4751C9.26809 2.4751 8.75948 2.68573 8.38442 3.06067L1.31342 10.1307C1.12747 10.3164 0.97995 10.537 0.879302 10.7798C0.778653 11.0226 0.726848 11.2828 0.726848 11.5457C0.726848 11.8085 0.778653 12.0688 0.879302 12.3116C0.97995 12.5543 1.12747 12.7749 1.31342 12.9607L8.38342 20.0307C8.56917 20.2166 8.78974 20.3641 9.03254 20.4648C9.27534 20.5654 9.53559 20.6172 9.79842 20.6172C10.0613 20.6172 10.3215 20.5654 10.5643 20.4648C10.8071 20.3641 11.0277 20.2166 11.2134 20.0307L18.2834 12.9607C18.4694 12.7749 18.6169 12.5543 18.7175 12.3116C18.8182 12.0688 18.87 11.8085 18.87 11.5457C18.87 11.2828 18.8182 11.0226 18.7175 10.7798C18.6169 10.537 18.4694 10.3164 18.2834 10.1307L17.2436 9.09086"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.79761 8.2749V11.2749"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.79761 14.2749V14.2849"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.434 6.4552L19.7074 1.18176"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2521 1.18176H19.7066V5.63702"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ExternalError;
